"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M23,1v22H1V1H23 M24,0H0v24h24V0L24,0z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#004864",
    points: "6.6,16.9 4.4,18.9 4.4,19 19.5,19 17.4,16.9     "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M20.7,10.9c-0.4-2-2.2-3.9-4.2-4.6l-2.2,2.2c1.4,0.4,3,1.5,3.4,3.1c0.4,1.6-0.5,2.9-1.6,3.8l0.6,0.7 c0.1,0.1,0.1,0.1,0.2,0.2h0c0.2,0.2,0.4,0.3,0.4,0.3s0.3-0.1,0.5-0.3h-0.1l0.1,0c0.2-0.1,0.4-0.2,0.5-0.3 C20,14.8,20.9,12.8,20.7,10.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M6.7,16.6l0.3-0.3H6.2C6.4,16.4,6.6,16.5,6.7,16.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M6.2,12.1c0.2-1.8,2-3.1,3.6-3.6L7.6,6.3c-2,0.7-4.1,2.6-4.3,4.8c-0.3,2.1,1.1,4.1,2.9,5.2l0.9,0L8,15.5 C6.8,14.6,6.1,13.5,6.2,12.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M12.9,15.3C13.4,11.9,14,8.6,14.4,5l-2.4,2.3L9.7,5l1.4,10.3H12.9z"
  }));
};

exports["default"] = _default;